import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Preserve the original error object structure for better debugging
    if (error.response && error.response.data) {
      // If we have response data, use it but preserve the original error
      const enhancedError = new Error(error.response.data.message || 'Server error');
      enhancedError.response = error.response;
      enhancedError.code = error.code;
      enhancedError.config = error.config;
      enhancedError.originalError = error;
      return Promise.reject(enhancedError);
    } else if (error.request) {
      // Network error or no response
      const networkError = new Error('Network error - server not responding');
      networkError.code = error.code || 'NETWORK_ERROR';
      networkError.request = error.request;
      networkError.config = error.config;
      networkError.originalError = error;
      return Promise.reject(networkError);
    } else {
      // Something else happened
      const genericError = new Error(error.message || 'Something went wrong');
      genericError.code = error.code;
      genericError.config = error.config;
      genericError.originalError = error;
      return Promise.reject(genericError);
    }
  }
);

export default axiosInstance;
